import { render } from "./CloseButton.vue?vue&type=template&id=1dd14104&scoped=true"
import script from "./CloseButton.vue?vue&type=script&lang=js"
export * from "./CloseButton.vue?vue&type=script&lang=js"

import "./CloseButton.vue?vue&type=style&index=0&id=1dd14104&scoped=true&lang=css"

import exportComponent from "/Users/lulua/Documents/lupanalua_oficial+dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dd14104"]])

export default __exports__